import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { useStore } from "../../../stores/StoreContext";

import "./Footer.scss";

const RawFooterComponent = () => {
  const { t } = useTranslation();
  const { navigationStore } = useStore();

  return (
    <div className="footer">
      <div className="links">
        {navigationStore.externalNavigationLinks
          ?.filter(link => link.urlKey?.length)
          .map((link, index) => (
            <Fragment key={link.labelKey}>
              {index != 0 && <div className="separator">/</div>}
              <a href={t(link?.urlKey ?? "")} className="link" target="_blank">
                {t(link.labelKey)}
              </a>
            </Fragment>
          ))}
      </div>
    </div>
  );
};

export const FooterComponent = observer(RawFooterComponent);
